import React from 'react';
import { MapPin, Gauge, Building, Waves } from 'lucide-react';
import './ProductsPage.css';

import Gasoline from '../assets/GasolineFuel.jpg';
import Diesel from '../assets/DieselFuel.jpg';
import Aviation from '../assets/AviationFuel.jpg';
import Petrochem from '../assets/Petrochemicals.jpg';
import Lubricants from '../assets/Lubricants.jpg';
import Asphalt from '../assets/Asphalt.jpg';
import CrudeBarrel from '../assets/crude-barrel-products.jpg';


const OperationsPage = () => {
	const companyName = process.env.REACT_APP_COMPANY_NAME;
	
  const facilities = [
    {
      name: 'Gdansk Refinery Complex',
      location: 'Gdansk, Poland',
      capacity: '250,000 BPD',
      type: 'Refinery',
      image: 'https://images.unsplash.com/photo-1588011930968-eadac80e6a5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxvaWwlMjByZWZpbmVyeXxlbnwwfHx8fDE3NjUxMzMzNDl8MA&ixlib=rb-4.1.0&q=85',
      features: [
        'Advanced catalytic cracking',
        'Hydroprocessing units',
        'On-site cogeneration plant'
      ]
    },
    {
      name: 'Baltic Offshore Platform',
      location: 'Baltic Sea',
      capacity: '150,000 BPD',
      type: 'Offshore',
      image: 'https://images.unsplash.com/photo-1578356058390-f58c575337a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxvZmZzaG9yZSUyMG9pbCUyMHJpZ3xlbnwwfHx8fDE3NjUxMzMzNTR8MA&ixlib=rb-4.1.0&q=85',
      features: [
        'Deep water drilling capability',
        'Enhanced oil recovery systems',
        'Automated safety protocols'
      ]
    },
    {
      name: 'Silesian Processing Plant',
      location: 'Katowice, Poland',
      capacity: '180,000 BPD',
      type: 'Processing',
      image: 'https://images.unsplash.com/photo-1602056820935-316884c035f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxvaWwlMjByZWZpbmVyeXxlbnwwfHx8fDE3NjUxMzMzNDl8MA&ixlib=rb-4.1.0&q=85',
      features: [
        'Natural gas processing',
        'Petrochemical production',
        'Waste heat recovery'
      ]
    }
    
  ];

  const infrastructure = [
    {
      icon: <Building size={32} />,
      title: 'Storage Capacity',
      value: '50M Barrels',
      description: 'Strategic crude and product storage terminals'
    },
    {
      icon: <MapPin size={32} />,
      title: 'Pipeline Network',
      value: '2,500+ Miles',
      description: 'Interstate crude and refined product pipelines'
    },
    {
      icon: <Gauge size={32} />,
      title: 'Processing Capacity',
      value: '2.5M BPD',
      description: 'Combined refining and processing throughput'
    },
    {
      icon: <Waves size={32} />,
      title: 'Marine Terminals',
      value: '8 Facilities',
      description: 'Deep-water port access for crude imports/exports'
    }
  ];

  const capabilities = [
    {
      title: 'Gasoline Fuel',
      description: 'High-performance motor fuel ensuring smooth ignition, efficiency, and cleaner combustion.',
      image:Gasoline
    },
    {
      title: 'Diesel Fuel',
      description: 'Low-sulfur diesel providing power, durability, and reliable heavy-duty performance.',
      image: Diesel
    },
    {
      title: 'Aviation Fuel',
      description: 'remium jet-grade fuel delivering stable combustion and maximum flight efficiency.',
      image:Aviation
    },
    {
      title: 'Petrochemicals',
      description: 'Core chemical feedstocks for plastics, manufacturing, pharmaceuticals, and industrial production.',
      image: Petrochem
    }
	,
    {
      title: 'Lubricants',
      description: 'High-grade oils reducing friction, wear, and improving engine lifespan.',
      image: Lubricants
    },
    {
      title: 'Asphalts',
      description: 'Durable road-grade material ideal for paving, roofing, and infrastructure projects.',
      image: Asphalt
    }
	
  ];

  return (
    <div className="operations-page">
      <section className="operations-hero">
        <div className="operations-hero-overlay"></div>
        <div className="operations-hero-content">
          <h1>Our Products</h1>
          <p>Comprehensive output portfolio tailored for diverse industrial and energy needs.</p>
        </div>
      </section>
     

	   <section className="section">
        <div className="container">
          <div  className="about-intro-grid">
            <div style={{Height: '100%'}} className="about-intro-imag">
              <img
                src={CrudeBarrel}
                alt="Crude Barrel"
				
              />
            </div>
            <div className="about-intro-content">
              <h2>Product Range and Capacity</h2>
              <p>
                Explore our extensive product range and high-volume production capacity, offering premium petroleum fuels, petrochemical derivatives, lubricants, and industrial-grade energy products. Engineered for quality, efficiency, and regulatory compliance, we supply reliable energy solutions for domestic and global markets.
              </p>
              <p>
                {companyName} offers an extensive range of high-grade petroleum products backed by advanced production capacity and rigorous quality control. Our modern refining facilities, powered by innovative Ag-Clean™ technology, ensure superior fuel efficiency, cleaner emissions, and consistent supply for domestic and international markets. From gasoline, diesel, aviation fuels, and petrochemicals to lubricants and industrial asphalts, we deliver products engineered to exceed global performance standards while supporting sustainable energy growth.
              </p>
            
            </div>
          </div>
        </div>
      </section>

      <section className="infrastructure-section">
        <div className="container">
          <h4 className="section-title" style={{ color: 'white' }}>High-Quality Petroleum Products for Industrial and Commercial Applications</h4>
          <div className="infrastructure-grid">
		  <p style={{ color: '#ffffff'}} >
		  {companyName} offers a comprehensive selection of high-quality petroleum products designed for superior performance, dependable supply, and strict regulatory compliance across global markets. Every stage of our refining process follows a rigorous quality assurance protocol, supported by modern processing units and continuous monitoring. This ensures each product batch remains consistent, safe, and fully aligned with international energy standards. Our portfolio includes a wide range of refined outputs tailored for industrial, commercial, and domestic applications:

		Diesel Fuel – Ultra-low sulfur diesel engineered for stable ignition, high energy efficiency, and reduced emissions, suitable for heavy machinery, transport fleets, and industrial operations.
		Naphtha & Kerosene – Critical feedstocks for petrochemical production, blending components for aviation fuel, and a reliable base for chemical manufacturing.
		Fuel Oil & Bitumen – Durable and energy-dense fuels designed for marine engines, thermal power generation, road surfacing, and asphalt production.
		Liquefied Petroleum Gas (LPG) – Clean-burning, versatile fuel for home heating, cooking, industrial burners, and energy-saving systems.
		</p>


          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <h2 className="section-title">Transportation Fuels & Special Products</h2>
          <p className="section-subtitle">
            Integrated operations delivering reliable energy solutions
          </p>

          <div className="capabilities-grid">
            {capabilities.map((capability, index) => (
              <div key={index} className="capability-card">
                <div className="capability-image">
                  <img src={capability.image} alt={capability.title} />
                </div>
                <div className="capability-content">
                  <h3>{capability.title}</h3>
                  <p>{capability.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


    </div>
  );
};

export default OperationsPage;